import "./ChangePassword.css";
import { useState } from "react";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import { changePassword } from "../../api/auth";
import Loader from "../../Components/Loader";
import { Snackbar, Alert } from '@mui/material';
import { getToken, getUserId } from "../../api/index";

function ChangePassword() {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [cnfPassword, setCnfPassword] = useState("");
    const [error, setError] = useState("");
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success' // 'success' | 'error' | 'warning' | 'info'
    });

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };

    const showSnackbar = (message, severity) => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    const validatePassword = (value, setError) => {
        const passwordRegex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

        if (value.length > 0 && value.length < 8) {
            setError("Password must be at least 8 characters");
            return false;
        }

        if (value.length > 0 && !passwordRegex.test(value)) {
            setError(
                "Password must include uppercase, lowercase, number, and special character"
            );
            return false;
        }

        setError("");
        return true;
    };

    const handleCurrentPasswordChange = (e) => {
        setCurrentPassword(e.target.value);
        setError("");
    }

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
        setError("");
    }

    const handleCnfPasswordChange = (e) => {
        setCnfPassword(e.target.value);
        setError("");
    }

    const handleSubmit = async () => {
        if (currentPassword === "" || newPassword === "" || cnfPassword === "") {
            setError("Please fill all the fields");
            return;
        }
        if (newPassword !== cnfPassword) {
            setError("Passwords do not match");
            return;
        }
        if (!validatePassword(currentPassword, setError)) {
            return;
        }
        if (!validatePassword(newPassword, setError)) {
            return;
        }
        setIsLoading(true);
        const token = getToken();
        const userId = getUserId();
        const credentials = {
            currentPassword: currentPassword,
            newPassword: newPassword,
            userId: userId
        }
        try {
            const response = await changePassword(credentials, token);
            console.log(response);
            showSnackbar('Password updated successfully!', 'success');
            setCurrentPassword("");
            setNewPassword("");
            setCnfPassword("");
        } catch (error) {
            console.log(error);
            setError(error.response.data.error);
            showSnackbar('Failed to update password. Please try again.', 'error');
        } finally {
            setIsLoading(false);
        }
    }


    return (
        <div className="Feeds">
            <div className="feedsContainer">
                <div className="changePasswordContainer">
                    <div className="changePasswordForm">
                        <label htmlFor="currentPassword" className="changePasswordLabel">Current Password</label>
                        <input type={showCurrentPassword ? "text" : "password"} id="currentPassword" className="changePasswordInput" placeholder="Enter your current password" value={currentPassword} onChange={handleCurrentPasswordChange} />
                        <span
                            className="eyeIcon"
                            onClick={() => {
                                setShowCurrentPassword((prev) => !prev);

                                if (showPassword) {
                                    setShowPassword(false);
                                }
                                if (showConfirmPassword) {
                                    setShowConfirmPassword(false);
                                }
                            }} style={{ top: '55%' }}
                        >
                            {showCurrentPassword ? (
                                <RemoveRedEyeRoundedIcon
                                    sx={{ height: "20px", fontSize: {
                                        xs: "12px",   // extra-small devices
                                        sm: "14px",   // small devices
                                        md: "16px",   // medium devices
                                        lg: "18px",   // large devices
                                        xl: "20px",   // extra-large devices
                                      }, }}
                                />
                            ) : (
                                <VisibilityOffRoundedIcon
                                    sx={{ height: "20px", fontSize: {
                                        xs: "12px",   // extra-small devices
                                        sm: "14px",   // small devices
                                        md: "16px",   // medium devices
                                        lg: "18px",   // large devices
                                        xl: "20px",   // extra-large devices
                                      }, }}
                                />
                            )}
                        </span>
                    </div>
                    <div className="changePasswordForm">
                        <label htmlFor="newPassword" className="changePasswordLabel">New Password</label>
                        <input type={showPassword ? "text" : "password"} id="newPassword" className="changePasswordInput" placeholder="Enter your new password" value={newPassword} onChange={handleNewPasswordChange} />
                        <span
                            className="eyeIcon"
                            onClick={() => {
                                setShowPassword((prev) => !prev);

                                if (showCurrentPassword) {
                                    setShowCurrentPassword(false);
                                }
                                if (showConfirmPassword) {
                                    setShowConfirmPassword(false);
                                }
                            }} style={{ top: '55%' }}
                        >
                            {showPassword ? (
                                <RemoveRedEyeRoundedIcon
                                    sx={{ height: "20px", fontSize: {
                                        xs: "12px",   // extra-small devices
                                        sm: "14px",   // small devices
                                        md: "16px",   // medium devices
                                        lg: "18px",   // large devices
                                        xl: "20px",   // extra-large devices
                                      }, }}
                                />
                            ) : (
                                <VisibilityOffRoundedIcon
                                    sx={{ height: "20px", fontSize: {
                                        xs: "12px",   // extra-small devices
                                        sm: "14px",   // small devices
                                        md: "16px",   // medium devices
                                        lg: "18px",   // large devices
                                        xl: "20px",   // extra-large devices
                                      }, }}
                                />
                            )}
                        </span>
                    </div>
                    <div className="changePasswordForm">
                        <label htmlFor="cnfPassword" className="changePasswordLabel">Confirm Password</label>
                        <input type={showConfirmPassword ? "text" : "password"} id="cnfPassword" className="changePasswordInput" placeholder="Confirm your new password" value={cnfPassword} onChange={handleCnfPasswordChange} />
                        <span
                            className="eyeIcon"
                            onClick={() => {
                                setShowConfirmPassword((prev) => !prev);

                                if (showCurrentPassword) {
                                    setShowCurrentPassword(false);
                                }
                                if (showPassword) {
                                    setShowPassword(false);
                                }
                            }} style={{ top: '55%' }}
                        >
                            {showConfirmPassword ? (
                                <RemoveRedEyeRoundedIcon
                                    sx={{ height: "20px", fontSize: {
                                        xs: "12px",   // extra-small devices
                                        sm: "14px",   // small devices
                                        md: "16px",   // medium devices
                                        lg: "18px",   // large devices
                                        xl: "20px",   // extra-large devices
                                      }, }}
                                />
                            ) : (
                                <VisibilityOffRoundedIcon
                                    sx={{ height: "20px", fontSize: {
                                        xs: "12px",   // extra-small devices
                                        sm: "14px",   // small devices
                                        md: "16px",   // medium devices
                                        lg: "18px",   // large devices
                                        xl: "20px",   // extra-large devices
                                      }, }}
                                />
                            )}
                        </span>
                    </div>
                    <div className="submitBtnContainer" style={{ marginTop: '5vh' }} onClick={handleSubmit}>
                        {isLoading ? <Loader /> : <button className="btnText">Save</button>}
                    </div>
                    {error && <div className="tooltip">{error}</div>}

                </div>

                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={4000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert 
                        onClose={handleCloseSnackbar} 
                        severity={snackbar.severity}
                        sx={{ width: '100%' }}
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    )
}

export default ChangePassword;
